/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import { H2 } from "@/components-shared/headers";
import PropCard from "@/components-shared/prop-card";
import PropCardSkeleton from "@/components-shared/prop-card-skeleton";
import { RootState } from "@/redux/store";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import PropsPagination from "./props-pagination";
import { useSearchParams } from "next/navigation";
import { useGetProps } from "../utils/get-props-hook";
import { useTranslations } from "next-intl";

const AllProps = () => {
  const t = useTranslations();
  const searchParams = useSearchParams();
  const { isLoggedIn } = useSelector((state: RootState) => state.login);

  const { data, isLoading, error, refetch } = useGetProps();

  useEffect(() => {
    refetch();
  }, [isLoggedIn]);

  return error || (!data?.properties?.length && !isLoading) ? (
    <H2 className="flex items-center justify-center h-64 text-gray-light">
      {t("allPropsMap.noData")}{" "}
    </H2>
  ) : (
    <div className="grid justify-center grid-cols-[repeat(auto-fill,minmax(20rem,1fr))] h-full gap-4 mb-8">
      {isLoading
        ? Array.from({ length: 9 }).map((_, i) => (
            <PropCardSkeleton key={`card ${i}`} />
          ))
        : data?.properties?.map((prop: Property) => (
            <PropCard
              key={prop.id}
              id={prop.id}
              propData={prop}
              image={prop?.media?.find((m) => m.isMain)?.url}
            />
          ))}

      <PropsPagination
        pagesCount={data?.pagesCount}
        page={
          "page" in searchParams ? +(searchParams.get("page") || 1) : data?.page
        }
      />
    </div>
  );
};

export default AllProps;
